module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/order_07-494a4b51724bf29c06db08bf02d9417a.png";